export default __webpack_public_path__ + "static/media/services_collaboration.e71db9ba.svg";